import DataTable from "ui/DataTable"
import { getHeaders } from "./headers"
import { useMemo } from "react"
import CustomPagination from "components/common/CustomPagination"
import moment from "moment"
import LoadMoreButton from "components/common/LoadMore"
import { Grid } from "antd"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import DataTableResponsive from "ui/DataTableResponsive"
import { Paragraph, Text } from "ui/Typography"
const { useBreakpoint } = Grid

const EmailHistoryTable = ({ data, page, metadata, pageSize, onPageChange, onPageSizeChange, onSortChange, onRowClick, setIsAppend }) => {
  const screens = useBreakpoint()
  const isMobile = !screens.md
  const { loading } = useSelector((state) => state.clients.emailLogs)

  const emailsData = useMemo(() => {
    return data.map((email) => {
      const { id, created_at, subject, message } = email || {}
      return {
        id,
        "Date Sent": moment(created_at).format("MM/DD/YY hh:mm A"),
        Subject: <Text fw={500}>{subject}</Text>,
        Message: (
          <Paragraph
            className="m-0"
            ellipsis={{
              rows: 3,
              tooltip: true
            }}
          >
            {message}
          </Paragraph>
        )
      }
    })
  }, [data])

  const dataSource = useMemo(() => {
    return (
      data?.map((email) => {
        const { id, created_at, subject, message } = email || {}
        return {
          key: id,
          created_at: moment(created_at).format("MM/DD/YY hh:mm A"),
          subject: <Text fw={500}>{subject}</Text>,
          message
        }
      }) || []
    )
  }, [data])

  const handleLoadMore = () => {
    onPageChange(page + 1)
    setIsAppend(true)
  }

  const isResultMoreThanPage = useMemo(() => metadata?.total_results > 10, [metadata?.total_results])

  const handleMobileRowClick = (data) => {
    onRowClick(data?.id)
  }

  return (
    <>
      {isMobile ? (
        <>
          <DataTableResponsive data={emailsData} onItemClick={handleMobileRowClick} />
          {isResultMoreThanPage && (
            <LoadMoreButton
              currentPage={page}
              totalPages={Math.ceil(metadata.total_results / pageSize)}
              loading={loading}
              onLoadMore={handleLoadMore}
              totalAvailable={metadata.total_results}
            />
          )}
        </>
      ) : (
        <>
          <DataTable columns={getHeaders()} dataSource={dataSource} pagination={false} onChange={onSortChange} onRowClick={onRowClick} />
          {isResultMoreThanPage && (
            <CustomPagination
              metadata={metadata}
              pageSize={pageSize}
              total={metadata?.total_results || 0}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          )}
        </>
      )}
    </>
  )
}

EmailHistoryTable.propTypes = {
  data: PropTypes.array,
  page: PropTypes.number,
  metadata: PropTypes.object,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSortChange: PropTypes.func,
  onRowClick: PropTypes.func,
  setIsAppend: PropTypes.func
}

export default EmailHistoryTable
